import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5497906d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5497906d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497906d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5497906d')) {
      api.createRecord('5497906d', component.options)
    } else {
      api.reload('5497906d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5497906d&scoped=true", function () {
      api.rerender('5497906d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/placementarea/index.vue"
export default component.exports